import Admin from "../../pages/Admin";
import { InternalUserRoles } from "../../constants/roles";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { ModuleRouteConfig, RouteConfig } from "../types";

export const BASE_PATH = "/admin";

export const baseRoute: ModuleRouteConfig = {
  path: BASE_PATH,
  component: Admin,
  allowedRoles: InternalUserRoles,
  label: "Admin",
  icon: () => <AdminPanelSettingsIcon />,
  isCustomIcon: false,
  hasDivider: true,
};

export const adminRoutes: { [key: string]: RouteConfig } = {
  admin: baseRoute,
};
